import React from "react";
import "../../style/news/consultativeWorkshopForUnesco.css";
import Comment from "../shared/Comment/Comment";
import Footer from "../shared/Footer/Footer";
import Navbar from "../shared/Navbar/Navbar";
import One from "../../images/Blogs-photo/12.05.2025/1.jpg";
import Two from "../../images/Blogs-photo/12.05.2025/2.jpg";
import Three from "../../images/Blogs-photo/12.05.2025/3.jpg";
import Four from "../../images/Blogs-photo/12.05.2025/4.jpg";
import Five from "../../images/Blogs-photo/12.05.2025/5.jpg";
import Six from "../../images/Blogs-photo/12.05.2025/6.jpg";
import Seven from "../../images/Blogs-photo/12.05.2025/7.jpg";
import Eight from "../../images/Blogs-photo/12.05.2025/8.jpg";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";
import { useEffect } from "react";
import TranslateButton from "../TranslateButton/TranslateButton";

const ConsultativeWorkshopUnesco = () => {
  useEffect(() => {
    document.title = `AshroyAngon | Consultative Workshop for UNESCO`;
  }, []);

  const shareUrl = "https://ashroyangon.org/consultative-workshop-for-unesco";

  return (
    <>
      <Navbar />
      <TranslateButton />

      <div className="consultative_workshop_section">
        <div className="blog_title">
          <div className="container">
            <h6>
              A consultative workshop was held on May 12, 2025, in Rangamati, Bangladesh, by Ashroy Angon Society (AAS), to gather information from stakeholders for a proposal to be submitted to the International Fund for Cultural Diversity (IFCD) of UNESCO.
            </h6>
            <h2>
              A consultative workshop was held on May 12, 2025, in Rangamati, Bangladesh, by Ashroy Angon Society (AAS), to gather information from stakeholders for a proposal to be submitted to the International Fund for Cultural Diversity (IFCD) of UNESCO.
            </h2>
            <h3>May 12, 2025</h3>
          </div>
        </div>
        <div className="image_part">
          <div className="header_image"></div>
          {/* Social Share Section Start */}
          <div className="social_share_wrapper">
            <div className="container">
              <div className="social_share_button">
                <FacebookShareButton
                  url={shareUrl}
                  target={"_blank"}
                  quote={"share facebook"}
                  hashtag={"#facebook"}
                >
                  <FacebookIcon size={35} round={true} />
                </FacebookShareButton>
                <TwitterShareButton
                  url={shareUrl}
                  target={"_blank"}
                  quote={"share twitter"}
                  hashtag={"#twitter"}
                >
                  <TwitterIcon size={35} round={true} />
                </TwitterShareButton>
                <LinkedinShareButton
                  url={shareUrl}
                  target={"_blank"}
                  quote={"share linkedin"}
                  hashtag={"#linkedin"}
                >
                  <LinkedinIcon size={35} round={true} />
                </LinkedinShareButton>
              </div>
            </div>
          </div>
          {/* Social Share Section End */}
        </div>
        <div className="content_wrapper">
          <div className="container">

            <img src={One} loading="lazy" alt="" />
            <img src={Two} loading="lazy" alt="" />
            <img src={Three} loading="lazy" alt="" />
            <img src={Four} loading="lazy" alt="" />
            <img src={Five} loading="lazy" alt="" />
            <img src={Six} loading="lazy" alt="" />
            <img src={Seven} loading="lazy" alt="" />
            <img src={Eight} loading="lazy" alt="" />

            <button>
              <a
                href="/all-blogs"
                target={"_blank"}
                id="style-2"
                data-replace="More Blogs"
              >
                <span>More Blogs</span>
              </a>
            </button>
          </div>
        </div>
      </div>

      {/* Comment Section */}
      <Comment />
      <Footer />
    </>
  );
};

export default ConsultativeWorkshopUnesco;
